import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { GET, POST_BLOB } from "config/api.config";
import {
    downloadBlobAsFile,
    resolveFilenameFromContentDisposition,
} from "helpers/GeneralHelper";

const normalizeYearOptions = (payload) => {
    const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload?.years)
                ? payload.years
                : Array.isArray(payload?.records)
                    ? payload.records
                    : [];

    return list
        .map((item) => {
            if (typeof item === "number" || typeof item === "string") {
                const year = String(item).trim();
                return year ? { value: year, label: year } : null;
            }

            const year = String(item?.year ?? item?.value ?? item?.label ?? "").trim();
            return year ? { value: year, label: year } : null;
        })
        .filter(Boolean);
};

const parseBlobErrorMessage = async (blob) => {
    if (!(blob instanceof Blob)) return "";
    try {
        const text = await blob.text();
        const json = JSON.parse(text);
        return json?.message || json?.error?.message || "";
    } catch {
        return "";
    }
};

/** GET `Report/month-summary/years` */
export const fetchMonthSummaryYearOptions = async () => {
    try {
        const response = await GET(REPORT.MONTH_SUMMARY_YEARS);
        return normalizeYearOptions(response?.data ?? response);
    } catch (error) {
        toast.error(error?.message);
        return [];
    }
};

/** POST `Report/month-summary/download` — returns Excel blob (.xlsx). */
export const downloadMonthSummaryReport = async (year = 0) => {
    const normalizedYear = Number(year) || 0;

    try {
        const response = await POST_BLOB(REPORT.MONTH_SUMMARY_DOWNLOAD, {
            year: normalizedYear,
        });

        if (!response?.data) {
            toast.error("Unable to download month summary report");
            return false;
        }

        const contentType = String(response.headers?.["content-type"] || "").toLowerCase();

        if (contentType.includes("application/json") || contentType.includes("text/json")) {
            const message = await parseBlobErrorMessage(response.data);
            toast.error(message || "Unable to download month summary report");
            return false;
        }

        const filename =
            resolveFilenameFromContentDisposition(
                response.headers?.["content-disposition"]
            ) || `month-summary-report-${normalizedYear}.xlsx`;

        return downloadBlobAsFile(response.data, filename);
    } catch (error) {
        toast.error(error?.message || "Unable to download month summary report");
        return false;
    }
};
